import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiList } = FiIcons;

const SegnalatorNav = ({ currentView, setCurrentView }) => {
  const { isDark } = useTheme();

  return (
    <nav className={`${
      isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
    } border-b shadow-sm`}>
      <div className="container mx-auto px-4">
        <div className="flex space-x-1">
          <button
            onClick={() => setCurrentView('segnalatore-dashboard')}
            className={`flex items-center space-x-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
              currentView === 'segnalatore-dashboard'
                ? isDark
                  ? 'text-blue-400 border-blue-400 bg-gray-700'
                  : 'text-blue-600 border-blue-600 bg-blue-50'
                : isDark
                  ? 'text-gray-300 border-transparent hover:text-blue-400 hover:bg-gray-700'
                  : 'text-gray-500 border-transparent hover:text-blue-600 hover:bg-gray-50'
            }`}
          >
            <SafeIcon icon={FiList} className="w-4 h-4" />
            <span>Le mie segnalazioni</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default SegnalatorNav;